<template>
  <div>
    <div v-if="step === 4" class="text-center">
      <h4>Save to "My Videos"</h4>
      <div style="80%">
        <b-form-textarea
          id="videoTitle"
          name="videoTitle"
          placeholder="Name Your Videos"
          v-model="videoTitle"
          rows="1"
        ></b-form-textarea>
      </div>
      <b-button
        type="button"
        variant="outline-primary"
        class="mt-4 rounded-pill"
        id="create"
        @click.prevent="handleCreate"
        >CREATE</b-button
      >
    </div>
  </div>
</template>
<script>
import Firebase from "firebase";
import db from "../db";

export default {
  name: "StepFour",
  mounted() {},
  data: function() {
    return {
      no_headshot: "https://i.imgur.com/Gcvs580m.png",
    };
  },
  computed: {
    uid: {
      get() {
        return this.$store.state.user.uid;
      },
    },
    srcVid: {
      get() {
        return this.$store.state.customization.srcVid;
      },
    },
    videoTitle: {
      get() {
        return this.$store.state.customization.videoTitle;
      },
      set(value) {
        this.$store.commit("changeVideoTitle", value);
      },
    },
    step: {
      get() {
        return this.$store.state.step;
      },
      set(value) {
        this.$store.commit("changeStep", value);
      },
    },
  },
  methods: {
    setStep: function(newStep) {
      this.step = newStep;
    },
    handleCreate: function() {
      this.addCustom(this.$store.state.customization);
      this.customization = {};
      this.setStep(5);
    },
    addCustom: function(payload) {
      db.collection("videos").add({
        srcVideo: payload.srcVid,
        headshot: payload.headshot,
        videoTitle: payload.videoTitle,
        introBlurb: payload.introBlurb,
        outroCTA: payload.outroCTA,
        outroPhone: payload.outroPhone,
        outroEmail: payload.outroEmail,
        name: payload.name,
        title: payload.title,
        customVideo: null,
        "render-status": "ready",
        createdAt: Firebase.firestore.FieldValue.serverTimestamp(),
        userID: this.uid,
      });
    },
  },
};
</script>
